import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS, Signal, Store} from '@gongxigames/framework/slot';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {specialInfoZoneStore} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';
import {$JurisdictionZoneMain, LabelsPrimary, LabelsSecondary} from './components/JurisdictionZoneMain';
import {Container} from 'pixi.js';

const JURISDICTION_ZONE_LINE_HEIGHT = 42;

export class JurisdictionZoneModule extends UIModuleV2 {
    public static NAME = 'JurisdictionZoneModule';
    public static layer = LAYERS.KEYPAD;

    private labelsPrimary!: LabelsPrimary;
    private labelsSecondary!: LabelsSecondary;

    container = new Container();

    public onInit(): void {
        this.labelsPrimary = {
            gameName: {
                val: slotStore.jurisdictionData_gameName,
                enabled: slotStore.jurisdictionData_gameName_enabled,
            },
            clock: {
                val: slotStore.jurisdictionData_clock,
                enabled: slotStore.jurisdictionData_clock_enabled,
            },
        };

        this.labelsSecondary = {
            pointsBalance: {
                val: this.getComputedPointsBalance(),
                enabled: slotStore.jurisdictionData_pointsBalance_enabled,
            },
            elapsedTime: {
                val:slotStore.jurisdictionData_elapsedTime,
                enabled:slotStore.jurisdictionData_elapsedTime_enabled,
            },
            netPosition: {
                localeId: 'netPositionBalance',
                val:slotStore.jurisdictionData_netPosition,
                enabled:slotStore.jurisdictionData_netPosition_enabled,
            },
            sessionEarnings: {
                localeId: 'sessionEarnings',
                val:slotStore.jurisdictionData_sessionEarnings,
                enabled:slotStore.jurisdictionData_sessionEarnings_enabled,
            },
            sessionBets: {
                localeId: 'sessionBets',
                val:slotStore.jurisdictionData_sessionBets,
                enabled:slotStore.jurisdictionData_sessionBets_enabled,
            },
            showMaxWinProbability: {
                localeId: 'maxWinProbability',
                val:slotStore.jurisdictionData_showMaxWinProbability,
                enabled:slotStore.jurisdictionData_showMaxWinProbability_enabled,
            },
            RTPWatermark: {
                localeId: 'RTPWatermark',
                val: slotStore.jurisdictionData_RTPWatermark,
                enabled:slotStore.jurisdictionData_RTPWatermark_enabled,
            },
        };

        this.updateInfoZoneStoreLines();
        this.buildComponent();
    }

    private buildComponent(): void {
        const component = $JurisdictionZoneMain({
            jurisdictionZoneHeight: specialInfoZoneStore.blackPanelHeight,
            labelsPrimary: this.labelsPrimary,
            labelsSecondary: this.labelsSecondary,
        }) as Container;

        this.container!.addChild(component);
    }

    private getComputedPointsBalance(): Signal<string> {
        return Store.computed(() => {
            const points = slotStore.jurisdictionData_pointsBalance.value;
            const label = slotStore.languageService.value!.get('pointsLabel');

            return `${label}: ${points}`;
        });
    }

    private updateInfoZoneStoreLines(): void {
        const lines = 1;

        // TODO: specialInfoZoneService should be refactored!
        // You can't modify the Store directly! It should be done thru events!
        specialInfoZoneStore.blackPanelHeight.value = lines * JURISDICTION_ZONE_LINE_HEIGHT;
        specialInfoZoneStore.numberOfRows.value = lines;
    }
}